import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getCookie } from '../helpers/Cookies';
import { cstToUTC } from '../Common/CommonHelper';

/* istanbul ignore next */
export const getCouponList = (params = {}) => {
    const context = RestClient.getContext();
    if (context.isPreview) {
        const previewDate = getCookie('DP_PREVIEW_DATE');
        if (previewDate) {
            const dateValue = cstToUTC(previewDate, context);
            const utcOfCSTPreviewDate = (dateValue || new Date()).toISOString();
            params.previewDate = utcOfCSTPreviewDate;
        }
    }

    try {
        const config = {
            apiHost: apiHosts.content,
            excludeVersion: true,
            isXCloudHeaderRequired: true,
            ...params,
        };

        return RestClient.get(config).then((json) => json.data);
    } catch (e) {
        return e;
    }
};
